export const statusCodes: Array<string> = [
    'In Planung',
    'In Durchführung',
    'Abgeschlossen',
];
